import data from '../components/knowledge/knowledgeBaseData.json';
import messages from './knowledge.en.json';
import {useTranslation} from './translation';

export function translateKnowledgeText(text) {
    return messages[text] || text;
}

// Keep identifiers, media, links and numeric values shared with the Russian data.
const sharedFields = new Set(['slug', 'id', 'src', 'url', 'variant', 'type', 'value']);
function translateContent(value, key) {
    if (sharedFields.has(key)) return value;
    if (typeof value === 'string') return translateKnowledgeText(value);
    if (Array.isArray(value)) return value.map(item => translateContent(item));
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([field, item]) => [field, translateContent(item, field)]));
    }
    return value;
}

const englishData = translateContent(data);

export function getKnowledgeData(english) {
    return english ? englishData : data;
}

export function useKnowledgeTranslation() {
    const {english, t} = useTranslation();
    return {english, t: text => english ? messages[text] || t(text) : text};
}
